<template>
  <v-container class="pt-8">
    <v-row>
      <v-col :cols="$vuetify.display.smAndDown ? 12 : 10" class="d-flex justify-center align-center mx-auto mb-2">
        <h1 :class="$vuetify.display.smAndDown ? 'display-2 center-text' : 'display-1'">Stock analyses in minutes!</h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col :cols="$vuetify.display.smAndDown ? 12 : 10" class="d-flex justify-center align-center mx-auto">
        <v-btn
          color="primary"
          class="text-capitalize"
          variant="outlined"
          size="x-large"
          :to="{ name: 'Sign In' }"
        >
          Get Started!
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col :cols="$vuetify.display.smAndDown ? 12 : 10"  class="d-flex mx-auto" v-if="summaries.length > 0">
        <v-carousel
          height="auto"
          :show-arrows="$vuetify.display.smAndDown ? false : 'hover'"
          cycle
          hide-delimiters
          hide-delimiter-background
        >
          <template v-slot:prev="{ props }">
            <v-btn color="primary" class="prev-btn v-window__left" variant="outlined" icon="mdi-chevron-left" size="x-large" density="compact" @click="props.onClick"></v-btn>
          </template>
          <template v-slot:next="{ props }">
            <v-btn color="primary" class="next-btn v-window__right" variant="outlined" icon="mdi-chevron-right" size="x-large" density="compact" @click="props.onClick"></v-btn>
          </template>
          <v-carousel-item
            v-for="{ symbol, timestamp, summary }, index of summaries"
            :key="hash({ index, symbol, timestamp })"
            :class="getPadding() + ' mb-12'"
          >
            <AnalysisBrief :symbol="symbol" :summary="summary" :timestamp="timestamp" :cta="fullAnalaysisCta" />
          </v-carousel-item>
        </v-carousel>
      </v-col>
    </v-row>
  </v-container>
</template>
<script lang="ts">

import { Options, Vue } from 'vue-class-component'
import { mapState } from 'vuex'
import { useRouter } from 'vue-router'
import { hash } from '@/utils/general'
import { LatestSummary } from '@/utils/api'
import AnalysisBrief from '@/components/AnalysisBrief.vue'


@Options({
  computed: {
    breakpoint(): string {
      return this.$vuetify.display.name
    },
    ...mapState(['authenticated', 'latestSummaries'])
  },
  watch: {
    breakpoint(value: any) {
      // change layout
    },
    // authenticated(value: boolean) {
    //   if (value) {
        
    //   }
    // }
  },
  components: {
    AnalysisBrief
  }
})
export default class HomeView extends Vue {
  public $vuetify: any
  private router = useRouter()
  public breakpoint!: string
  public authenticated!: boolean
  public hash = hash
  public latestSummaries!: LatestSummary[]

  get summaries(): LatestSummary[] {
    return this.latestSummaries ?? []
  }

  public async mounted() {
    await this.$store.dispatch('checkAuth')
    await this.$store.dispatch('getLatestSummaries', { count: 5 })
  }

  public getPadding() {
    switch (this.breakpoint) {
      case 'xs':
        return 'mx-0'
      case 'sm':
        return 'mx-0'
      case 'md':
        return 'mx-6'
      case 'lg':
        return 'mx-16'
      case 'xl':
        return 'mx-16'
      default:
        return 'mx-8'
    }
  }

  public async fullAnalaysisCta(symbol?: string) {
    console.log(`clicked ${symbol}`)
    await this.router.push('/sign-in')
  }
}
</script>
<style lang="scss">
.access-text {
  max-width: 400px;
}
.center-text {
  text-align: center;
}
.prev-btn {
  position: absolute !important;
  top: 25vh;
}
.next-btn {
  position: absolute !important;
  top: 25vh;
  right: 16px;
}
</style>